import { useCallback, useRef, useState } from "react";
import type { Dispatch, MutableRefObject, SetStateAction } from "react";

const isFunction = <State>(
  value: SetStateAction<State>
): value is (previousState: State) => State => typeof value === "function";

export const useStateRef = <State>(
  initialState: State
): [State, Dispatch<SetStateAction<State>>, MutableRefObject<State>] => {
  const [state, setState] = useState(initialState);
  const ref = useRef(state);

  const dispatch = useCallback((setStateAction: SetStateAction<State>) => {
    ref.current = isFunction(setStateAction) ? setStateAction(ref.current) : setStateAction;

    setState(ref.current);
  }, []);

  return [state, dispatch, ref];
};
